// extracted by mini-css-extract-plugin
export default {"container":"AlignText-container___Vm1Kj","button":"AlignText-button___Vba7V","list":"AlignText-list___G2MUs","label":"AlignText-label___yx7ZF"};